import { pageFromJSON } from "@pjn/core/model/Page";
/**
 * Crea un handler para respuestas Axios que mapea el payload usando el mapper especificado
 *
 * @export
 * @template T tipo de objeto a devolver
 * @template any
 * @param {(json: any) => T} [mapper] funcion que mapea el payload a la instancia deseada
 * @returns {(response: AxiosResponse<T>) => T} handler de axios que usa el mapper
 */
export function toEntity(mapper) {
    // Si el mapper existe, se usa, si no se devuelve el payload intacto
    return response => (mapper ? mapper(response.data) : response.data);
}
/**
 * Crea un handler que mapea el payload de la respuesta o bien una lista any[] a una lista de items tipados.
 *
 * Para cada item de la respuesta se llama el mapper, permitiendo crear las instancias.
 *
 * @export
 * @template T tipo de objeto a devolver en la lista
 * @param {(json: any) => T} mapper funcion que mapea cada item del payload a la instancia deseada
 * @returns {((response: any[] | AxiosResponse<T>) => T[])} handler de axios que mapea a una lista tipada
 */
export function toList(mapper) {
    return response => {
        if (Array.isArray(response)) {
            // Si la response ya es el array, se mapea
            return mapper ? response.map(mapper) : response;
        }
        else {
            // Si no, se castea el payload a array para mapearlo.
            return mapper ? response.data.map(mapper) : response.data;
        }
    };
}
/**
 * Crea un handler que mapea una pagina o el payload del response Axios a una pagina de items tipados.
 *
 * @export
 * @template T tipo de objeto a devolver en la pagina
 * @template any
 * @param {(json: any) => T} [itemMapper] funcion que mapea cada item de la pagina a la instancia deseada
 * @param {(json: any) => Page<T>} [pageMapper] funcion que mapea los atributos de la pagina (default: `items`, `number`, `next`, `total`)
 * @returns {((json: Page<any> | AxiosResponse<Page<T>>) => Page<T>)} handler de axion que mapea a una pagina tipada
 */
export function toPage(itemMapper, pageMapper) {
    return response => {
        // Se obtiene la pagina de jsons, ya sea directamente del parametro o de la response Axios
        const json = (response.status
            ? response.data
            : response);
        return pageFromJSON(json, itemMapper, pageMapper);
    };
}
/**
 * Convierte un objecto JS (mapa) en query string para hacer un request, incluyendo el `?` inicial.
 *
 * Encodea los parametros automaticamente y **excluye** los `undefined` o `null` (no viajan en el request).
 *
 * @param map
 */
export function queryString(map) {
    const qs = Object.entries(map)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    if (qs === '')
        return '';
    return '?' + qs;
}
//# sourceMappingURL=helpers.js.map